<rt-group class="group-activities">
  @for (group of state.groupedActivities!; track groupsTrackBy($index, group)) {
    <rt-group class="group-activities-day">
      <div class="group-date">
        <span>{{ group.date }}</span>
      </div>
      <rt-box variant="no-padding vertical">
        @for (activity of group.activities; track activitiesTrackBy($index, activity)) {
          <div class="activity-single">
            <rt-activity-item
              [activity]="activity"
              [shortMessage]="shortMessage"
              [canManageCandidates]="canManageCandidates"
              (activityItemClick)="activityItemClick.emit($event)"
              (readUnreadClick)="readUnreadClick.emit($event)"
            >
            </rt-activity-item>
            <rt-divider></rt-divider>
          </div>
        }
      </rt-box>
    </rt-group>
  }
</rt-group>
